import { Box, Flex, Text, Wrap, WrapItem, Tag, TagLabel, TagCloseButton, Center, Spinner, Input, } from "@chakra-ui/react";
import { CustomButton, CustomToast } from "../../../../components";
import { useEffect, useState } from "react";
import PlusIcon from "../../../../assets/images/Vector.svg";
import { useFetch } from "../../../../hooks/useFetch";
import { IWebSiteSetting } from "./model";
import MyDiv from "./webSiteSetting.style";

const WebSiteSetting = () => {
  const [record, setRecord] = useState<IWebSiteSetting | null>(null);
  const [pendingEmails, setPendingEmails] = useState<string[]>([]);
  const [emailInput, setEmailInput] = useState("");
  const [status, setStatus] = useState(true);
  const { addToast } = CustomToast();
  const { fetchApi, loading } = useFetch(addToast);

  useEffect(() => {
    loadEmails();
  }, []);

  const loadEmails = async () => {
    const response = await fetchApi<IWebSiteSetting | null>("WebSite_Setting", "GET");
    if (response) {
      setRecord(response);
      setPendingEmails(response.email ? response.email.split(",").map((e) => e.trim()).filter(Boolean) : []);
      setStatus(response.is_Active);
    }
  };

  const isValidEmail = (val: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val);

  const addChip = () => {
    const val = emailInput.trim().replace(/,$/, "");
    if (!val) return;
    if (!isValidEmail(val)) {
      addToast({ status: "error", message: `"${val}" is not a valid email` });
      return;
    }
    if (pendingEmails.some((e) => e.toLowerCase() === val.toLowerCase())) {
      addToast({ status: "warning", message: `"${val}" is already added` });
      setEmailInput("");
      return;
    }
    setPendingEmails((prev) => [...prev, val]);
    setEmailInput("");
  };

  const handleEmailKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      addChip();
    } else if (e.key === "Backspace" && !emailInput && pendingEmails.length) {
      setPendingEmails((prev) => prev.slice(0, -1));
    }
  };

  const removeChip = (val: string) => {
    setPendingEmails((prev) => prev.filter((e) => e !== val));
  };

  const handleSave = async () => {
    let toSave = [...pendingEmails];
    if (emailInput.trim() && isValidEmail(emailInput.trim())) {
      toSave = [...toSave, emailInput.trim()];
    }
    if (!toSave.length) {
      addToast({ status: "error", message: "Please add at least one email" });
      return;
    }

    const payload = { email: toSave.join(","), is_Active: status };

    const response = record
      ? await fetchApi(`WebSite_Setting/${record.id}`, "PUT", payload, null, "Emails updated successfully")
      : await fetchApi("WebSite_Setting", "POST", payload, null, "Emails added successfully");

    if (response) {
      setEmailInput("");
      loadEmails();
    }
  };

  return (
    <MyDiv>
      <Box position="relative" minH="200px">
        {loading ? (
          <Center position="absolute" top={0} left={0} right={0} bottom={0}>
            <Spinner thickness="4px" speed="0.65s" emptyColor="gray.200" color="#006838" size="xl" />
          </Center>
        ) : (
          <>
            <Flex className="page_heading flex_header">
              <Text className="font-poppins text_semibold text_3xl">
               Emails Setting 
              </Text>
            </Flex>

            <Flex align="center" gap={3} mb={4}>
              <Box border="1px solid #E2E8F0" borderRadius="4px" p={2} display="flex" flexWrap="wrap" alignItems="center" gap={2} flex="1"
              >
                <Wrap>
                  {pendingEmails.map((email) => (
                    <WrapItem key={email}>
                      <Tag borderRadius="full" variant="solid" bg="#006838" color="white">
                        <TagLabel>{email}</TagLabel>
                        <TagCloseButton onClick={() => removeChip(email)} />
                      </Tag>
                    </WrapItem>
                  ))}
                </Wrap>
                <Input border="none" _focus={{ boxShadow: "none" }} placeholder="Type an email and press Enter or comma..." value={emailInput}
                  onChange={(e) => setEmailInput(e.target.value)} onKeyDown={handleEmailKeyDown} onBlur={addChip} minW="150px" flex="1"
                />
              </Box>
            </Flex>
            <Flex justify='flex-end'>  
              <CustomButton title={record ? "Update" : "Add Emails"} className="btn font-poppins text_sm text_medium"  onClick={handleSave}  />
            </Flex>
          </>
        )}
      </Box>
    </MyDiv>
  );
};

export default WebSiteSetting;